export const googlePlaceIdMock = 'placeIdMock';